/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 474d49ccb7e9a761c7ae6261823001a3 */

import { ConcreteRequest } from "relay-runtime";

export type CountryCode = "AE" | "AR" | "AT" | "AU" | "BE" | "BG" | "BR" | "CA" | "CH" | "CL" | "CN" | "CO" | "CR" | "CZ" | "DE" | "DK" | "EC" | "EE" | "EG" | "ES" | "FI" | "FL" | "FR" | "GB" | "GR" | "GT" | "HR" | "HU" | "IE" | "IN" | "IT" | "JP" | "KE" | "KR" | "LT" | "LU" | "LV" | "MA" | "MX" | "MY" | "NL" | "NO" | "NZ" | "PA" | "PE" | "PL" | "PT" | "RO" | "SA" | "SE" | "SG" | "SI" | "SK" | "TN" | "TR" | "UA" | "UK" | "UM" | "US" | "VG" | "VI" | "ZA" | "%future added value";
export type DigitalRiverCreditCardBrand = "AMERICAN_EXPRESS" | "DISCOVER" | "MASTERCARD" | "VISA" | "%future added value";
export type DigitalRiverPaymentType = "CREDIT_CARD" | "PAYPAL" | "%future added value";
export type PartnerProgramEnrollmentBillingCycle = "ANNUAL" | "MONTHLY" | "%future added value";
export type PartnerProgramEnrollmentMarket = "CAN_001" | "NA_001" | "%future added value";
export type PartnerProgramEnrollmentStatus = "ACTIVE" | "CANCELLED" | "EXPIRED" | "NOT_STARTED" | "PENDING" | "WITHDRAWN" | "%future added value";
export type PaymentMethodFormPaymentMethodUpdateMutationVariables = {
    programEnrollmentId: string;
    paymentSourceId: string;
};
export type PaymentMethodFormPaymentMethodUpdateMutationResponse = {
    readonly updatePartnerProgramEnrollmentPaymentSource: {
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
            readonly field: ReadonlyArray<string | null> | null;
        }> | null;
        readonly partnerProgramEnrollment: {
            readonly id: string | null;
            readonly __typename: string;
            readonly partnerProgram: {
                readonly name: string | null;
            } | null;
            readonly status: PartnerProgramEnrollmentStatus | null;
            readonly activationDate: string | null;
            readonly billingCycle: PartnerProgramEnrollmentBillingCycle | null;
            readonly enrollmentMarket: PartnerProgramEnrollmentMarket | null;
            readonly purchaseDate: string | null;
            readonly cancellationDate: string | null;
            readonly cancellationReason: string | null;
            readonly billableQuantity: number | null;
            readonly autoRenew: boolean | null;
            readonly sapSubscriptionDocumentNumber: string | null;
            readonly paymentSource: {
                readonly paymentSourceId: string | null;
                readonly clientSecret: string | null;
                readonly paymentSessionId: string | null;
                readonly payPalBillingToken: string | null;
                readonly type: DigitalRiverPaymentType | null;
                readonly creditCard: {
                    readonly lastFourDigits: string | null;
                    readonly expirationMonth: number | null;
                    readonly brand: DigitalRiverCreditCardBrand | null;
                    readonly expirationYear: number | null;
                } | null;
                readonly billTo: {
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly organization: string | null;
                    readonly email: string | null;
                    readonly address: {
                        readonly addressLine1: string | null;
                        readonly addressLine2: string | null;
                        readonly city: string | null;
                        readonly stateProvinceRegionCode: string | null;
                        readonly zipPostalCode: string | null;
                        readonly countryCode: CountryCode | null;
                    } | null;
                } | null;
            } | null;
            readonly logoApproved?: boolean | null | undefined;
        } | null;
    } | null;
};
export type PaymentMethodFormPaymentMethodUpdateMutation = {
    readonly response: PaymentMethodFormPaymentMethodUpdateMutationResponse;
    readonly variables: PaymentMethodFormPaymentMethodUpdateMutationVariables;
};



/*
mutation PaymentMethodFormPaymentMethodUpdateMutation(
  $programEnrollmentId: ID!
  $paymentSourceId: String!
) {
  updatePartnerProgramEnrollmentPaymentSource(enrollmentId: $programEnrollmentId, paymentSourceId: $paymentSourceId) {
    errors {
      message
      field
    }
    partnerProgramEnrollment {
      id
      __typename
      partnerProgram {
        __typename
        name
        id
      }
      status
      activationDate
      billingCycle
      enrollmentMarket
      purchaseDate
      cancellationDate
      cancellationReason
      billableQuantity
      autoRenew
      ... on HomeownerAppBrandingPartnerProgramEnrollment {
        logoApproved
      }
      sapSubscriptionDocumentNumber
      paymentSource {
        paymentSourceId
        clientSecret
        paymentSessionId
        payPalBillingToken
        type
        creditCard {
          lastFourDigits
          expirationMonth
          brand
          expirationYear
        }
        billTo {
          firstName
          lastName
          organization
          email
          address {
            addressLine1
            addressLine2
            city
            stateProvinceRegionCode
            zipPostalCode
            countryCode
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paymentSourceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "programEnrollmentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "enrollmentId",
    "variableName": "programEnrollmentId"
  },
  {
    "kind": "Variable",
    "name": "paymentSourceId",
    "variableName": "paymentSourceId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Error",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activationDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingCycle",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enrollmentMarket",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "purchaseDate",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationReason",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableQuantity",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoRenew",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sapSubscriptionDocumentNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "DigitalRiverPaymentSource",
  "kind": "LinkedField",
  "name": "paymentSource",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSourceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientSecret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentSessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payPalBillingToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverCreditCard",
      "kind": "LinkedField",
      "name": "creditCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFourDigits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expirationYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DigitalRiverBillTo",
      "kind": "LinkedField",
      "name": "billTo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organization",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addressLine2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stateProvinceRegionCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipPostalCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoApproved",
      "storageKey": null
    }
  ],
  "type": "HomeownerAppBrandingPartnerProgramEnrollment",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentMethodFormPaymentMethodUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PartnerProgramEnrollmentPayload",
        "kind": "LinkedField",
        "name": "updatePartnerProgramEnrollmentPaymentSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "partnerProgramEnrollment",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "partnerProgram",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PaymentMethodFormPaymentMethodUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PartnerProgramEnrollmentPayload",
        "kind": "LinkedField",
        "name": "updatePartnerProgramEnrollmentPaymentSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "partnerProgramEnrollment",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "partnerProgram",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "474d49ccb7e9a761c7ae6261823001a3",
    "metadata": {},
    "name": "PaymentMethodFormPaymentMethodUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '55499dcd0ff92835e88c9b7752b7710d';
export default node;
